module.exports = __webpack_public_path__ + "static/img/5.aeb4b28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/5.png
// module id = NKEy
// module chunks = 0